import type { ReactElement } from 'react';
import { useUIDSeed } from 'react-uid';
import Plan, { PlanType } from 'models/Plan';
import mostPopularImgUrl from 'consumer/components/green-arrow-right.svg';

type Props = {
    plan: Plan;
    handleSelectExtras: (extras: number) => void;
    showMostPopularWidget?: boolean;
};

function SelectableExtrasQuantity({
  plan,
  handleSelectExtras,
  showMostPopularWidget = true,
}: Props): ReactElement {
  const seed = useUIDSeed();

  return (
    <fieldset>
      <div className="c-plan-select__dinners">
        <legend id="plan-servings">
          Meals per week
        </legend>

        {plan.type === PlanType.PROGRAMS ? (
          <div className="c-plan-select__program-options">
            <strong>4 </strong>
            Ready-to-Eat Breakfasts,
            {' '}
            <strong>4 </strong>
            Lunches,
            {' '}
            <strong>4 </strong>
            Dinners
          </div>
        ) : (
          <ul
            role="radiogroup"
            className="c-switch"
            aria-labelledby="plan-servings"
          >
            {Plan.getExtraDinnerOptions(plan.type, false, plan.name).map((extraDinners) => (
              <li key={seed(extraDinners)}>
                <button
                  type="button"
                  role="radio"
                  aria-label={`Select ${plan.includedDinners + extraDinners} Meals`}
                  aria-checked={plan.extraDinners === extraDinners}
                  className={plan.extraDinners === extraDinners ? 'is-selected' : ''}
                  onClick={() => handleSelectExtras(extraDinners)}
                >
                  {plan.includedDinners + extraDinners}
                  <span className="sr-only">serving</span>
                </button>

                {showMostPopularWidget && extraDinners === plan.defaultExtraDinners && (
                <div className="c-plan-select__most-popular-widget">
                  <img
                    src={mostPopularImgUrl}
                    className="c-plan-select__most-popular-arrow"
                    alt="green arrow right"
                  />
                  <div className="c-plan-select__most-popular-text">
                    Most Popular
                  </div>
                </div>
                )}

              </li>
            ))}
          </ul>
        )}
      </div>
    </fieldset>
  );
}

export default SelectableExtrasQuantity;
